import React, { Component } from "react";
import { Row } from "antd";
import { getText } from "../configure/utils";
import "./footer.style.css";
import { LanguageContext } from "../../context/LanguageContext";

export default class Footer extends Component {
  static contextType = LanguageContext;
  render() {
    return (
      <footer className="mainfooter ">
        <div className="disclaimer ">
          <Row>
            <b>{getText("footer.distitle")}</b>
          </Row>
          <Row className="text-footer">
            <p>{getText("footer.dissubtitle")}</p>
            <br />
          </Row>
          {getText("footer.title").map((title, index) => (
            <Row className="text-footer" key={index}>
              <p>
                <b>{title}</b>
                {getText("footer.subtitle")[index]}
              </p>
            </Row>
          ))}
        </div>
        {/* Explanation:
                config.js: Returns both titles and subtitles as arrays.
                footer.js: Uses map() on titles and accesses the corresponding subtitle by index. If there's no matching subtitle, it gracefully falls back to an empty string.
                This setup ensures that both title and subtitle pairs render correctly in your footer. */}
      </footer>
    );
  }
}
